<template>
  <nuttrema-layout-content>
    <template slot="header">
      <team-member-standard-header
        :meta="meta"
        :showEdit="false"
        :TeamMemberDetails="TeamMemberDetails">
      </team-member-standard-header>
    </template>

    <template slot="central">
      <nuttrema-loader v-if="TeamMemberDetails.fetching || RegionalAndLanguageAll.fetching"></nuttrema-loader>
      <form-team-member-main-details
         v-else
        :TeamMemberDetails="TeamMemberDetails"
        :RegionalAndLanguageAll="RegionalAndLanguageAll">
      </form-team-member-main-details>
    </template>
  </nuttrema-layout-content>
</template>

<script>
import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import TeamMemberStandardHeader from 'components/pages/professional/persons/my-team/shared/blocks/cmpt-team-member-standard-header';

import FormTeamMemberMainDetails from './form-team-member-main-details';

export default {
  name: 'page-team-member-main-details',
  mixins: [PageProps],
  props: {
    id: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      edit: false,
    };
  },
  components: {
    NuttremaLayoutContent,
    TeamMemberStandardHeader,
    FormTeamMemberMainDetails,
  },
  computed: {
    TeamMemberDetails() {
      return this.$store.getters.TeamMemberDetails(this.id);
    },
    RegionalAndLanguageAll() {
      return this.$store.getters.RegionalAndLanguageAll;
    },
  },
  created() {
    this.$store.dispatch('GetRegionalAndLanguageAll', { language_app_support: true, measurement_system_optional: true });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearRegionalAndLanguageAll');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/my-team/main-details/page-team-member-main-details.vue